import React, { useState } from 'react';
import { PhoneIcon, SendIcon, CheckCircleIcon, Loader2Icon } from 'lucide-react';
export function ContactCTA() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    city: '',
    message: ''
  });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.id]: e.target.value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.phone.trim()) {
      alert('נא למלא שם וטלפון');
      return;
    }
    setStatus('loading');
    try {
      const response = await fetch('https://formsubmit.co/ajax/mumheyinstelazia@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          שם: formData.name,
          טלפון: formData.phone,
          עיר: formData.city,
          הודעה: formData.message || 'לא צוין',
          _subject: 'פנייה חדשה מהאתר – יבש-טק פרו'
        })
      });
      if (response.ok) {
        setStatus('success');
        setFormData({
          name: '',
          phone: '',
          city: '',
          message: ''
        });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };
  return <section className="bg-[#0a1628] text-white py-16 px-4 md:px-8" data-id="element-37">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-start" data-id="element-38">
        {/* Left Side (Text) */}
        <div className="text-center lg:text-right" data-id="element-39">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black mb-6 leading-tight" data-id="element-40">
            מוכנים לפתור <br data-id="element-41" />
            את הבעיה?
          </h2>

          <div className="mb-6" data-id="element-42">
            <div className="flex flex-col gap-1 mb-4" data-id="element-43">
              <a href="tel:0523552222" className="block text-3xl md:text-5xl lg:text-6xl font-black text-[#f97316] hover:text-orange-400 transition-colors" data-id="element-44">
                <span dir="ltr" data-id="element-45">052-355-2222</span>
              </a>
              <a href="tel:0545188888" className="block text-3xl md:text-5xl lg:text-6xl font-black text-[#f97316] hover:text-orange-400 transition-colors" data-id="element-46">
                <span dir="ltr" data-id="element-47">054-518-8888</span>
              </a>
            </div>
            <div className="inline-block bg-orange-500/20 text-orange-300 px-4 py-2 rounded-full text-base font-bold border border-orange-500/30" data-id="element-48">
              ⚡ מגיעים תוך שעה – 24/7
            </div>
          </div>

          <p className="text-lg text-gray-300 mb-6 max-w-lg mx-auto lg:mx-0" data-id="element-49">
            אל תתנו לרטיבות להתפשט. שיחת ייעוץ אחת יכולה לחסוך לכם אלפי שקלים
            ועוגמת נפש.
          </p>

          <div className="flex flex-col sm:flex-row gap-3" data-id="element-50">
            <a href="tel:0523552222" className="inline-flex items-center justify-center gap-2 bg-[#f97316] hover:bg-orange-600 text-white px-6 py-4 text-lg font-bold rounded-lg shadow-lg transition-all transform hover:scale-105" data-id="element-51">
              <PhoneIcon className="w-5 h-5" data-id="element-52" />
              052-355-2222
            </a>
            <a href="tel:0545188888" className="inline-flex items-center justify-center gap-2 bg-[#f97316] hover:bg-orange-600 text-white px-6 py-4 text-lg font-bold rounded-lg shadow-lg transition-all transform hover:scale-105" data-id="element-53">
              <PhoneIcon className="w-5 h-5" data-id="element-54" />
              054-518-8888
            </a>
          </div>
        </div>

        {/* Right Side (Form) */}
        <div className="bg-white text-gray-900 p-6 md:p-8 rounded-2xl shadow-2xl w-full" data-id="element-55">
          <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-56">
            השאירו פרטים ונחזור אליכם
          </h3>

          {status === 'success' ? <div className="text-center py-10" data-id="element-57">
              <CheckCircleIcon className="w-16 h-16 text-green-500 mx-auto mb-4" data-id="element-58" />
              <h4 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-59">
                הפרטים נשלחו בהצלחה!
              </h4>
              <p className="text-gray-600 mb-6" data-id="element-60">נחזור אליכם תוך 10 דקות.</p>
              <button onClick={() => setStatus('idle')} className="text-[#f97316] font-bold hover:underline" data-id="element-61">
                שליחת פנייה נוספת
              </button>
            </div> : <form className="space-y-4" onSubmit={handleSubmit} data-id="element-62">
              <div data-id="element-63">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-64">
                  שם מלא
                </label>
                <input type="text" id="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#f97316] focus:border-transparent outline-none transition-all" placeholder="ישראל ישראלי" required data-id="element-65" />
              </div>

              <div data-id="element-66">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-67">
                  טלפון
                </label>
                <input type="tel" id="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#f97316] focus:border-transparent outline-none transition-all" placeholder="050-000-0000" required data-id="element-68" />
              </div>

              <div data-id="element-69">
                <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-70">
                  עיר מגורים
                </label>
                <input type="text" id="city" value={formData.city} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#f97316] focus:border-transparent outline-none transition-all" placeholder="לדוגמה: תל אביב" data-id="element-71" />
              </div>

              <div data-id="element-72">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-73">
                  תיאור הבעיה (אופציונלי)
                </label>
                <textarea id="message" rows={3} value={formData.message} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#f97316] focus:border-transparent outline-none transition-all resize-none" placeholder="יש לי רטיבות בתקרה..." data-id="element-74"></textarea>
              </div>

              {status === 'error' && <div className="bg-red-50 text-red-700 px-4 py-3 rounded-lg text-sm text-center border border-red-200" data-id="element-75">
                  אירעה שגיאה בשליחה. נסו שוב או התקשרו ישירות.
                </div>}

              <button type="submit" disabled={status === 'loading'} className="w-full bg-[#f97316] hover:bg-orange-600 disabled:bg-orange-400 text-white font-bold py-4 rounded-lg shadow-md transition-all flex items-center justify-center gap-2 text-lg mt-2" data-id="element-76">
                {status === 'loading' ? <>
                    שולח...
                    <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-77" />
                  </> : <>
                    שלחו פרטים – נחזור תוך 10 דקות
                    <SendIcon className="w-5 h-5" data-id="element-78" />
                  </>}
              </button>
            </form>}

          <div className="text-center mt-6 pt-6 border-t border-gray-100" data-id="element-79">
            <p className="text-gray-500 text-sm mb-2" data-id="element-80">או התקשרו ישירות:</p>
            <div className="flex flex-col gap-1" data-id="element-81">
              <a href="tel:0523552222" className="text-2xl font-black text-[#0a1628] hover:text-[#f97316]" data-id="element-82">
                052-355-2222
              </a>
              <a href="tel:0545188888" className="text-2xl font-black text-[#0a1628] hover:text-[#f97316]" data-id="element-83">
                054-518-8888
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}